var isGuidedSwitch = function (loadedPlatform, featureFlags) {
    return (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.defaultGuidedSwitch) && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.guidedSwitching);
};
export default isGuidedSwitch;
